import Component from '../abstracts/Component';
import AccordionMixinComponent from './mixins/AccordionMixinComponent';

export default class SeoTextComponent extends Component {
    get SELECTORS() {
      return {
        body: '[data-body]',
        cta: '[data-cta]',
        iconOpen: '[data-cta-icon="open"]',
        iconClose: '[data-cta-icon="close"]',
      }
    }

    constructor(elem) {
      super(elem);
      this.accordion = new AccordionMixinComponent(elem);
    }

    readDOM() {
      this.dom = {
        body: this.$component.querySelector(this.SELECTORS.body),
        cta: this.$component.querySelector(this.SELECTORS.cta),
        iconOpen: this.$component.querySelector(this.SELECTORS.iconOpen),
        iconClose: this.$component.querySelector(this.SELECTORS.iconClose),
      }
    }

    bindEvents() {
      this.dom.cta.addEventListener('click', () => {
        this.accordion.toggle();
      });
    }

    render() {
      this.readDOM();
      this.bindEvents();
    }
}

